module.exports = __webpack_public_path__ + "img/avatar3.c785bec5.png";